import withProps from '@atlassian/jira-common-with-props/src/index.tsx';
import CreateDialogLoader from './create-dialog-loader/index.tsx';
import StatelessButton from './stateless-button/index.tsx';
import CreateBoardsButton from './view.tsx';

export default withProps({
	CreateDialogLoader,
	StatelessButton,
	// @ts-expect-error - TS2345 - Argument of type 'FC<Props>' is not assignable to parameter of type 'AbstractComponent<{ CreateDialogLoader: AbstractComponent<Partial<{ showCreateBoardDialog: () => Promise<void>; }>, unknown>; StatelessButton: any; }, unknown>'.
})(CreateBoardsButton);
